module.exports = __webpack_public_path__ + "img/English Sharp Shooter Unlocked.5d9d1d0.png";